import { render, staticRenderFns } from "./SimpleAppDetails.vue?vue&type=template&id=b85eccc8&scoped=true&"
import script from "./SimpleAppDetails.vue?vue&type=script&lang=ts&"
export * from "./SimpleAppDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleAppDetails.vue?vue&type=style&index=0&id=b85eccc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85eccc8",
  null
  
)

export default component.exports